import type { AdminLang } from "../labels";
import { authAz, authEn, authRu } from "./auth";
import { commonAz, commonEn, commonRu, fieldsAz, fieldsEn, fieldsRu } from "./common";
import { dashboardAz, dashboardEn, dashboardRu } from "./dashboard";

export const appMessages: Record<
  AdminLang,
  {
    auth: typeof authRu;
    common: typeof commonRu;
    fields: typeof fieldsRu;
    dashboard: typeof dashboardRu;
  }
> = {
  ru: { auth: authRu, common: commonRu, fields: fieldsRu, dashboard: dashboardRu },
  en: { auth: authEn, common: commonEn, fields: fieldsEn, dashboard: dashboardEn },
  az: { auth: authAz, common: commonAz, fields: fieldsAz, dashboard: dashboardAz },
};
